module.exports = __webpack_public_path__ + "static/media/background.29d9d874.jpg";